import React from 'react'
import { withIcon } from '../../withIcon'

function CaretUpIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M5.42073 14.6522L18.5798 14.6522C18.7449 14.6522 18.8956 14.5643 18.9637 14.4285C19.0307 14.2936 19.0039 14.1348 18.8923 14.024L12.3128 7.46694C12.1543 7.30814 11.8462 7.30814 11.6866 7.46694L5.10822 14.024C4.9966 14.1348 4.9687 14.2936 5.03678 14.4285C5.10375 14.5643 5.25443 14.6522 5.42073 14.6522Z" fill={color}/>
    </svg>
  )
}

export default withIcon(CaretUpIcon)
